const REGEX = /\/(member|pro)-dashboard\/notes-and-forms\/.*/;
/**
 * check if the page is for printing, which should change the height
 */
export default function canPrintMultiPage(pathname: string) {
  return pathname.search(REGEX) > -1;
}
